(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionBtns = [...document.querySelectorAll('.accordion')];
    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle('is-open');
        let content = this.nextElementSibling;
        content.style.maxHeight = (content.style.maxHeight)?null:`${content.scrollHeight}px`
      };
    });
  });

  } catch(e) { console.error(e); }
})();
})();
